import type { FormEvent, ReactNode } from "react";
import PageBreadcrumb from "../common/PageBreadCrumb";
import AdminPageShell from "./AdminPageShell";
import AdminCard from "./AdminCard";
import AdminFormActions from "./AdminFormActions";
import { adminAlertErrorClass, adminSpinnerClass } from "./adminStyles";

type AdminFormPageProps = {
  pageTitle: string;
  description?: string;
  error?: string;
  loading?: boolean;
  children: ReactNode;
  listRoute?: string;
  onSubmit?: (e: FormEvent) => void;
  saving?: boolean;
  saveLabel?: string;
  showActions?: boolean;
};

export default function AdminFormPage({
  pageTitle,
  description,
  error,
  loading = false,
  children,
  listRoute,
  onSubmit,
  saving = false,
  saveLabel = "Save",
  showActions = true,
}: AdminFormPageProps) {
  return (
    <AdminPageShell className="w-full">
      <PageBreadcrumb pageTitle={pageTitle} description={description} />

      <AdminCard className="w-full">
        {error && <div className={`mb-6 ${adminAlertErrorClass}`}>{error}</div>}

        {loading ? (
          <div className="flex justify-center py-16">
            <div className={adminSpinnerClass} />
          </div>
        ) : onSubmit ? (
          <form onSubmit={onSubmit} className="w-full space-y-8">
            {children}
            {showActions && listRoute && (
              <AdminFormActions listRoute={listRoute} saving={saving} saveLabel={saveLabel} />
            )}
          </form>
        ) : (
          <div className="w-full space-y-8">{children}</div>
        )}
      </AdminCard>
    </AdminPageShell>
  );
}
